import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FormCheckbox } from 'eone-ui/forms/form-checkbox';
import { isEmpty } from 'lodash-es';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import { handleFieldUp } from './helper';

interface SCFormFieldCheckboxProps extends SCFormFieldProps {
  AutoFocus?: boolean;
  Icon?: IconProp;
  Label?: string;
  subLabel?: string;
  onChange?: (newValue: boolean) => void;
}

const SCFormFieldCheckbox = ({
  label,
  name,
  required,
  disabled,
  rules,
  defaultValue,
  onChange,
  subLabel,
  ...rest
}: SCFormFieldCheckboxProps) => {
  return (
    <SCFormField
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      rules={rules}
      defaultValue={defaultValue ?? false}
    >
      {({ field }) => {
        const { OnChange: OnFieldChange, ...restField } = handleFieldUp(field, {
          disabledRef: true,
        });

        return (
          <div style={{ display: 'flex', gap: 5 }}>
            {/* Crying, it should be onToggle instead of onChange */}
            <FormCheckbox
              {...restField}
              OnToggle={(newValue) => {
                onChange?.(newValue);
                OnFieldChange(newValue);
              }}
              ReadOnly={restField.Disabled}
              Label={label}
              {...rest}
            />
            {!isEmpty(subLabel) && (
              <label className="eone-ui-form-checkbox-subheading-container">
                <span>
                  {''}
                  {subLabel}
                </span>
              </label>
            )}
          </div>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldCheckbox };
export type { SCFormFieldCheckboxProps };
